/*
  Bebezik sepet çekmecesi (cart-drawer + cart-drawer-items).

  Bu sürümde:
  - Mendil metinleri düzeltildi: Standart 1×, İkili 2×.
  - Ürün sayfası hero'sunun sepete ekleme kodunu EZEN yama kaldırıldı. Eski yama 12 sn'de
    zaman aşımına düşüp ürün eklenmiş olsa bile müşteriye hata gösteriyordu. Sepete ekleme
    artık yalnızca bebezik-bundle-hero.pre-action-layout-20260918.js içinde (25 sn + 3 kontrol).
*/
function normalizeBebezikBundleCards(root) {
  root?.querySelectorAll?.('[data-bb-bundle-card]').forEach((card) => {
    const type = String(card.dataset.bundleType || '').toLowerCase();
    const copy = type === 'duo'
      ? { title: 'İkili Avantaj Seti', meta: '2× Biberon Destek Yastığı · 2× önlük hediye · 2× mendil hediye', role: 'İkili set' }
      : type === 'basic'
        ? { title: 'Standart Paket', meta: '1× Biberon Destek Yastığı · 1× önlük hediye · 1× mendil hediye', role: 'Ana ürün' }
        : null;
    if (!copy) return;
    const title = card.querySelector('.bb-bundle-card__title');
    const meta = card.querySelector('.bb-bundle-card__meta');
    const role = card.querySelector('[data-bundle-role="main"] .bb-bundle-card__role');
    if (title && title.textContent !== copy.title) title.textContent = copy.title;
    if (meta && meta.textContent !== copy.meta) meta.textContent = copy.meta;
    if (role && role.textContent !== copy.role) role.textContent = copy.role;
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.bindOverlay();
    this.bindCartIcon();
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (!overlay || overlay.dataset.bbBound) return;
    overlay.dataset.bbBound = '1';
    overlay.addEventListener('click', this.close.bind(this));
  }

  bindCartIcon() {
    const link = document.querySelector('#cart-icon-bubble');
    if (!link || link.dataset.bbDrawerBound) return;
    link.dataset.bbDrawerBound = '1';
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'dialog');
    link.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(link);
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.activeElement = triggeredBy;
    requestAnimationFrame(() => this.classList.add('animate', 'active'));
    document.body.classList.add('overflow-hidden');
    this.querySelector('cart-drawer-items')?.dispatchViewEvent?.();
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  parse(html, selector) {
    if (typeof html !== 'string' || !html.trim()) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  renderContents(state) {
    const sections = state?.sections;
    const html = sections?.['cart-drawer'];
    const parsedRoot = this.parse(html, 'cart-drawer');
    const next = this.parse(html, '#CartDrawer');
    const current = this.querySelector('#CartDrawer');
    if (!parsedRoot || !next || !current) {
      console.error('[Bebezik] Geçerli cart-drawer section alınamadı; boş drawer açılmadı.');
      return false;
    }

    const empty = parsedRoot.classList.contains('is-empty');
    current.replaceChildren(...Array.from(next.childNodes, (node) => node.cloneNode(true)));

    const icon = document.getElementById('cart-icon-bubble');
    const iconSection = this.parse(sections?.['cart-icon-bubble'], '.shopify-section');
    if (icon && iconSection) icon.innerHTML = iconSection.innerHTML;

    this.productId = state?.id ?? null;
    this.classList.toggle('is-empty', empty);
    this.querySelector('.drawer__inner')?.classList.toggle('is-empty', empty);
    this.querySelector('cart-drawer-items')?.classList.toggle('is-empty', empty);
    this.bindOverlay();
    normalizeBebezikBundleCards(this);
    requestAnimationFrame(() => this.open());
    return true;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return this.parse(html, selector)?.innerHTML ?? null;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);

/*
  Çekmecedeki butonlar: "Paketi kaldır", tekli ürün silme ve önlük önerisi.
  Bu butonların daha önce hiç kodu yoktu; basınca hiçbir şey olmuyordu.
  Olaylar capture aşamasında yakalanıyor ki başka bir kod aynı işlemi ikinci kez yapmasın.
*/
(() => {
  'use strict';
  if (window.__bbCartDrawerActions) return;
  window.__bbCartDrawerActions = true;

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const TIMEOUT_MS = 20000;
  const cartUrl = () => (window.routes?.cart_url || '/cart').replace(/\/$/, '');
  const jsUrl = (route, fallback) => `${(route || fallback).replace(/\.js$/, '')}.js`;

  const timedFetch = (url, options = {}, ms = TIMEOUT_MS) => {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = controller ? setTimeout(() => controller.abort(), ms) : 0;
    return fetch(url, controller ? { ...options, signal: controller.signal } : options).finally(() => clearTimeout(timer));
  };

  const postJson = async (url, body) => {
    const response = await timedFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: cartUrl() })
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'İşlem tamamlanamadı.');
    return data;
  };

  const getCart = async () => {
    const response = await timedFetch(jsUrl(window.routes?.cart_url, '/cart'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Sepet okunamadı.');
    return response.json();
  };

  const refreshFromServer = async () => {
    const response = await timedFetch(`${cartUrl()}?sections=${SECTIONS.join(',')}`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    return response.ok ? response.json() : null;
  };

  const render = async (data) => {
    const drawer = document.querySelector('cart-drawer');
    let sections = data?.sections;
    if (!sections?.['cart-drawer']) sections = await refreshFromServer().catch(() => null);
    if (!drawer || !sections || drawer.renderContents?.({ id: null, sections }) === false) {
      window.location.reload();
      return;
    }
    const detail = { source: 'bebezik-cart-drawer', cart: data };
    document.dispatchEvent(new CustomEvent('bebezik:cart-updated', { detail }));
    // eslint-disable-next-line no-undef
    const events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    // eslint-disable-next-line no-undef
    const publishFn = typeof publish === 'function' ? publish : window.publish;
    if (typeof publishFn === 'function' && events?.cartUpdate) {
      try { publishFn(events.cartUpdate, { source: 'bebezik-cart-drawer', cartData: data }); } catch (_) {}
    }
  };

  const showError = (message) => {
    const box = document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = message || '';
  };

  const withBusy = async (button, busyText, work) => {
    if (!button || button.dataset.bbBusy === '1') return;
    const original = button.innerHTML;
    button.dataset.bbBusy = '1';
    button.disabled = true;
    if (busyText) button.textContent = busyText;
    showError('');
    try {
      await work();
    } catch (error) {
      console.error('[Bebezik] Sepet işlemi hatası:', error);
      if (button.isConnected) {
        button.innerHTML = original;
        button.disabled = false;
        delete button.dataset.bbBusy;
      }
      showError(error?.name === 'AbortError'
        ? 'Bağlantı yavaş. Sepeti yenileyip tekrar deneyin.'
        : (error?.message || 'İşlem tamamlanamadı.'));
    }
  };

  const removeBundle = (button) => withBusy(button, 'Kaldırılıyor…', async () => {
    const bundleId = button.getAttribute('data-bb-remove-bundle');
    const cart = await getCart();
    const updates = {};
    (cart.items || []).forEach((item) => {
      const p = item.properties || {};
      if (p._bundle_id === bundleId || p._bb_upsell_for === bundleId) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) {
      await render(null);
      return;
    }
    await render(await postJson(jsUrl(window.routes?.cart_update_url, '/cart/update'), { updates }));
  });

  const removeLine = (button) => withBusy(button, '', async () => {
    const key = button.getAttribute('data-bb-remove-line');
    await render(await postJson(jsUrl(window.routes?.cart_change_url, '/cart/change'), { id: key, quantity: 0 }));
  });

  const upsellBox = (el) => el.closest('[data-bb-upsell]');

  const revealUpsell = (button) => {
    const box = upsellBox(button);
    const options = box?.querySelector('[data-bb-upsell-options]');
    if (!options) return;
    options.hidden = false;
    button.hidden = true;
  };

  const selectUpsell = (radio) => {
    const box = upsellBox(radio);
    const add = box?.querySelector('[data-bb-upsell-add]');
    if (!add) return;
    add.disabled = false;
    add.textContent = `Sepete Ekle · ${box.getAttribute('data-bb-upsell-price-label') || ''}`.trim();
  };

  const addUpsell = (button) => withBusy(button, 'Ekleniyor…', async () => {
    const box = upsellBox(button);
    const radio = box?.querySelector('input[name="bb_upsell"]:checked');
    if (!radio) throw new Error('Önce bir model seçin.');
    const bundleId = document.querySelector('[data-bb-bundle-card]')?.getAttribute('data-bundle-id') || '';
    const properties = { _bb_upsell: 'bib' };
    if (bundleId) properties._bb_upsell_for = bundleId;
    await render(await postJson(jsUrl(window.routes?.cart_add_url, '/cart/add'), {
      items: [{ id: Number(radio.value), quantity: 1, properties }]
    }));
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.closest('cart-drawer')) return;

    const actions = [
      ['[data-bb-remove-bundle]', removeBundle],
      ['[data-bb-remove-line]', removeLine],
      ['[data-bb-upsell-reveal]', revealUpsell],
      ['[data-bb-upsell-add]', addUpsell]
    ];
    for (const [selector, action] of actions) {
      const button = target.closest(selector);
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        action(button);
        return;
      }
    }
  }, true);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target instanceof Element && target.matches('cart-drawer [data-bb-upsell] input[name="bb_upsell"]')) {
      selectUpsell(target);
    }
  }, true);
})();